import React, { useEffect, useRef } from 'react';

/**
 * A read-only preview of a past version, laid over the editing canvas so the editor's own frame
 * (and any unsaved edits in it) stays untouched underneath. Same sandbox and server-side CSP as the
 * editor; links, buttons and forms are cancelled so the frame never navigates to the live site.
 */
const VersionFrame = ({ html, style, title }) => {
  const ref = useRef(null);

  useEffect(() => {
    const frame = ref.current;
    if (!frame || html == null) return undefined;
    const cancel = (e) => {
      if (e.type === 'submit' || e.target?.closest?.('a, button, summary, label')) e.preventDefault();
    };
    let doc = null;
    const onLoad = () => {
      doc = frame.contentDocument;
      doc?.addEventListener('click', cancel, true);
      doc?.addEventListener('submit', cancel, true);
      frame.setAttribute('data-ready', 'true');
    };
    // Listener before srcdoc, as in EditorCanvas: WebKit is unreliable otherwise.
    frame.addEventListener('load', onLoad);
    frame.srcdoc = html;
    return () => {
      frame.removeEventListener('load', onLoad);
      doc?.removeEventListener('click', cancel, true);
      doc?.removeEventListener('submit', cancel, true);
    };
  }, [html]);

  return (
    <iframe
      key={html}
      ref={ref}
      title={title}
      className="mse-frame mse-version-frame"
      style={style}
      sandbox="allow-same-origin allow-scripts"
    />
  );
};

export default VersionFrame;
